import { OpportunityActivityResultModel } from './opportunityActivityResult.model';
import { VehicleSummaryModel } from './vehicle.model';
import { SaleResultModel } from './saleResult.model';
import { LookupModel } from './../shared/lookup.model';
import { ContactResultModel } from './contact.model';
import { SaleDetailsModel } from './saleDetails.model';
import { ReportParamsPayloadModel } from './reportSpec.model';

export class TasksSearchResult
{
	tasks: TaskModel[];
	pageSize: number;
	pageNumber: number;
	resultCount: number;
}

export class TaskModel
{
	name: string;
	reference: string;
	comment: string;
	description: string;
	createdById: string;
	modifiedById: string;
    completedById: string;
	createdDate: Date;
	startDate: Date;
	modifiedDate: Date;
	taskTypeId: string;
	taskStatusId: string;
	taskPriorityId: string;
	taskColorId: string;
	assigneeId: string;
	vehicle1Id: string;
	vehicle2Id: string;
	sale1Id: string;
	sale2Id: string;
	contact1Id: string;
	contact2Id: string;
	saleProduct1Id: string;
	opportActivity1Id: string;
	createdBy: ContactResultModel;
	modifiedBy: ContactResultModel;
    completedBy: ContactResultModel;
	taskType: LookupModel;
	taskStatus: LookupModel;
	taskPriority: LookupModel;
	taskColor: LookupModel;
	assignee: ContactResultModel;
	vehicle1: VehicleSummaryModel;
	vehicle2: VehicleSummaryModel;
	sale1: SaleDetailsModel;
	sale2: SaleDetailsModel;
	contact1: ContactResultModel;
	contact2: ContactResultModel;
	saleProduct1: any; //SaleProductModel;
	opportActivity1: OpportunityActivityResultModel;
	id: string;
	reminderSecs: number;
    reportParamsPayload: ReportParamsPayloadModel;

	//Transient
	imageUrl: string;
}
